import type { FilterKey } from 'src/common/components/filters/types';
import { LOCATION_FILTER_KEYS } from '@/common/api/locationTableFilters';
import { getLoopTeamFilterKeys, type LoopTeamFilterKey } from '@/common/api/loopTeamTableFilters';
import {
  OPEN_POSITION_FILTER_KEYS,
  type OpenPositionFilterKey,
} from '@/common/api/openPositionTableFilters';
import { RESOURCE_FILTER_KEYS } from '@/common/api/resourceTableFilters';
import { SKILL_FILTER_KEYS } from '@/common/api/skillTableFilters';
import { TEAMS_PICKLIST_FILTERS } from '@/common/api/teamsTableFilters';
import { TEAM_FILTER_KEYS } from '@/common/api/teamTableFilters';
import {
  BOOLEAN_FILTERS,
  CODE_FILTERS,
  type CompactFilterKey,
  DATE_FILTERS,
  FILTER_KEYS,
  INSIGHTS_FILTER_KEYS,
  type InsightsFilterKey,
  PICKLIST_FILTERS,
  type ResourceFilterKey,
  type TeamFilterKey,
  type TeamsFilterKey,
} from './filterKeyTypes';

export const isInsightsFilterKey = (key: string): key is InsightsFilterKey => {
  return INSIGHTS_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isLocationFilterKey = (key: string): key is (typeof LOCATION_FILTER_KEYS)[number] => {
  return LOCATION_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isResourceFilterKey = (key: string): key is ResourceFilterKey => {
  return RESOURCE_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isSkillFilterKey = (key: string): key is (typeof SKILL_FILTER_KEYS)[number] => {
  return SKILL_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isOpenPositionFilterKey = (key: string): key is OpenPositionFilterKey => {
  return OPEN_POSITION_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isTeamsFilterKey = (key: string): key is TeamsFilterKey => {
  return TEAMS_PICKLIST_FILTERS.some((filterKey) => filterKey === key);
};

export const isTeamFilterKey = (key: string): key is TeamFilterKey => {
  return TEAM_FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isLoopTeamFilterKey = (key: string): key is LoopTeamFilterKey => {
  return getLoopTeamFilterKeys().some((filterKey) => filterKey === key);
};

export const isCompactFilterKey = (key: string): key is CompactFilterKey => {
  return FILTER_KEYS.some((filterKey) => filterKey === key);
};

export const isPicklistFilterKey = (
  key: CompactFilterKey,
): key is (typeof PICKLIST_FILTERS)[number] => {
  return PICKLIST_FILTERS.some((filterKey) => filterKey === key);
};

export const isCodeFilterKey = (key: string): key is (typeof CODE_FILTERS)[number] => {
  return CODE_FILTERS.some((filterKey) => filterKey === key);
};

export const isDateFilterKey = (key: CompactFilterKey): key is (typeof DATE_FILTERS)[number] => {
  return DATE_FILTERS.some((filterKey) => filterKey === key);
};

export const isBooleanFilterKey = (key: FilterKey) => {
  return BOOLEAN_FILTERS.some((filterKey) => filterKey === key);
};
